const reportsTypes = {

  index: {
    request: "REPORTS_INDEX_REQUEST",
    success: "REPORTS_INDEX_SUCCESS",
    failure: "REPORTS_INDEX_FAILURE"
  },

  create: {
    request: "CREATE_REPORT_REQUEST",
    success: "CREATE_REPORT_SUCCESS",
    failure: "CREATE_REPORT_FAILURE",
    after_redirect: "CREATE_REPORT_AFTER_REDIRECT"
  },

  publish: {
    request: "PUBLISH_REPORT_REQUEST",
    success: "PUBLISH_REPORT_SUCCESS",
    success_minimal: "PUBLISH_REPORT_SUCCESS_MINIMAL",
    failure: "PUBLISH_REPORT_FAILURE",
  },

  update_xml: {
    request: "UPDATE_XML_REQUEST",
    success: "UPDATE_XML_SUCCESS",
    success_minimal: "UPDATE_XML_SUCCESS_MINIMAL",
    failure: "UPDATE_XML_FAILURE",
  },

  unpublish: {
    request: "UNPUBLISH_REPORT_REQUEST",
    success: "UNPUBLISH_REPORT_SUCCESS",
    success_minimal: "UNPUBLISH_REPORT_SUCCESS_MINIMAL",
    failure: "UNPUBLISH_REPORT_FAILURE",
  },

  publish_all: {
    request: "PUBLISH_ALL_REQUEST",
    success: "PUBLISH_ALL_SUCCESS",
    failure: "PUBLISH_ALL_FAILURE",
  },

  unpublish_all: {
    request: "UNPUBLISH_ALL_REQUEST",
    success: "UNPUBLISH_ALL_SUCCESS",
    failure: "UNPUBLISH_ALL_FAILURE",
  },

  get: {
    request: "GET_PROJECT_REQUEST",
    success: "GET_PROJECT_SUCCESS",
    failure: "GET_PROJECT_FAILURE",
    success_minimal: "GET_PROJECT_SUCCESS_MINIMAL",
    refresh_request: "GET_PROJECT_REFRESH_REQUEST",
    reset_redirect: "RESET_REPORT_REDIRECT",
    success_excel: "GET_PROJECT_EXCEL_SUCCESS"
  },

  create_optimized: {
    request: "CREATE_OPTIMIZED_REPORT_REQUEST",
    success: "CREATE_OPTIMIZED_REPORT_SUCCESS",
    failure: "CREATE_OPTIMIZED_REPORT_FAILURE"
  },

  archive: {
    request: "ARCHIVE_REPORT_REQUEST",
    success: "ARCHIVE_REPORT_SUCCESS",
    failure: "ARCHIVE_REPORT_FAILURE"
  },

  project_archive: {
    request: "PROJECT_ARCHIVE_REPORT_REQUEST",
    success: "PROJECT_ARCHIVE_REPORT_SUCCESS",
    failure: "PROJECT_ARCHIVE_REPORT_FAILURE"
  },

  restore: {
    request: "RESTORE_REPORT_REQUEST",
    success: "RESTORE_REPORT_SUCCESS",
    success_minimal: "RESTORE_REPORT_SUCCESS_MINIMAL",
    failure: "RESTORE_REPORT_FAILURE"
  },

  destroy: {
    request: "DESTROY_REPORT_REQUEST",
    success: "DESTROY_REPORT_SUCCESS",
    failure: "DESTROY_REPORT_FAILURE"
  },

  reset_errors: "RESET_REPORT_ERRORS"

}

export default reportsTypes



// WEBPACK FOOTER //
// ./src/js/constants/reportsTypes.js